import { useState, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import axios from 'axios';

const useAuthenticatedData = (url) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const { instance, accounts } = useMsal();

  useEffect(() => {
    const fetchData = async () => {
      if (!accounts.length) {
        setIsLoading(false);
        return;
      }
     
      setIsLoading(true);
      try {
       
        await instance.initialize();

        const accessToken = await instance.acquireTokenSilent({
      //  const accessToken = await instance.loginRedirect({
          scopes: ['api://82ba1170-03da-46d4-be4b-dcc3fb4473f1/access_as_user'],
          account: accounts[0],
        });

        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${accessToken.accessToken}` },
        });

        setData(response.data);
        setError(null);
      } catch (error) {
        console.error('Error fetching data:', error);
        setError(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [url, instance, accounts]);

  return  { data, isLoading, error };
};

export default useAuthenticatedData;
